import { makeCancellableAPIRequest } from "./index";

const ImpervaAPI = {
    getConfigs() {
        return makeCancellableAPIRequest(
            "GET",
            `/api/imperva`
        )
    },
    createOrUpdateConfig(data) {
        return makeCancellableAPIRequest(
            data.id ? "PUT" : "POST",
            `/api/imperva` + (data.id ? `/${data.id}` : ""),
            {
                data
            }
        )
    },
    deleteConfig(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/imperva/${id}`
        )
    },
    getImperva() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/imperva/stats"
        );
    },
    getImpervaLogs() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/imperva/logs/all"
        );
    },
    addImpervaLogNotes(logId, notes) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/imperva/logs/add-comment/${logId}`,
            {
                params: { notes }
            }
        );
    },
    syncImperva(logId) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/imperva/config/start/${logId}`
        )
    },
    updateSubProduct(logId, subProductId) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/imperva/log/subproduct/${logId}/${subProductId}`
        )
    }
}

export default ImpervaAPI;